import { UIEvent, useState } from "react";

type UseScrollTopReturnType = [
  number,
  { onScroll?: (event: UIEvent<HTMLElement>) => void },
];

export const useScrollTop = (): UseScrollTopReturnType => {
  const [scrollTop, setScrollTop] = useState(0);
  const onScroll = (event: UIEvent<HTMLElement>) =>
    setScrollTop((event?.target as HTMLElement)?.scrollTop);
  return [scrollTop, { onScroll }];
};
